import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import classNames from 'classnames';
import { loader } from 'graphql.macro';
import { useMutation, useQuery, useApolloClient } from '@apollo/react-hooks';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from 'react-router-dom';
import {
  Button,
  Container,
  Menu,
  MenuItem,
} from '@material-ui/core';
import SideList from './sidelist';
import globalStyles from '../../layout/globalStyles';
import styles from './styles';
import Logo from '../../../assets/img/logo.svg';
import Login from '../../auth/forms/login/login-form';
import SignUpForm from '../../auth/forms/signup/signup-form';
import ForgotPassword from '../../auth/forms/forgot-password/forgot-password-form';
import ResetPassword from '../../auth/forms/reset-password/reset-password-form';
import combineStyles from '../../../utilities/combineStyles';
import AboutUs from './aboutUs';
import WhatWeOffer from './whatWeOffer';
import OurWork from './ourWork';
import EvidenceHub from './evidenceHub';

const UPDATE_DIALOG = loader( '../../../graphql/schema/ui/update-dialog.graphql' );
const GET_AUTH_INFO = loader( '../../../graphql/schema/auth/auth-info.graphql' );

const adminUrl = process.env.REACT_APP_ADMIN_URL;
const SITE_LINK = process.env.REACT_APP_SHARE_ICON_LINK;

const Header = ( props ) => {
  const { classes, history } = props;

  const apolloClient = useApolloClient();
  const [email, setEmail] = useState( '' );
  const [anchorEl, setAnchorEl] = useState( null );
  const [sidebarMenu, setSidebar] = useState( false );
  const [scrollClass, setScrollClass] = useState( false );

  const { data } = useQuery( GET_AUTH_INFO, {
    onCompleted() {
      const token = localStorage.getItem( 'app-token' );
      if ( token ) {
        apolloClient.writeData( { data: { isLoggedIn: true } } );
      }
    },
  } );

  const [updateLoginDialog] = useMutation( UPDATE_DIALOG, {
    variables: { id: 'login', isOpen: true },
  } );

  const [updateSignUpDialog] = useMutation( UPDATE_DIALOG, {
    variables: { id: 'signUp', isOpen: true },
  } );

  const handleEmail = ( emailAddress ) => {
    setEmail( emailAddress );
  };

  const handleClick = ( e ) => {
    setAnchorEl( e.currentTarget );
  };

  const handleClose = () => {
    setAnchorEl( null );
  };

  const handleLogout = () => {
    setSidebar( false );
    localStorage.removeItem( 'app-token' );
    apolloClient.resetStore();
    history.push( '/' );
  };

  const handleSidebar = () => {
    setSidebar( !sidebarMenu );
  };

  useEffect( () => {
    const handleScroll = () => {
      if ( window.scrollY > 0 ) {
        // setScrollClass( true );
        // Fixed menu is removed
        setScrollClass( false );
      } else {
        setScrollClass( false );
      }
    };

    window.addEventListener( 'scroll', handleScroll );

    return () => {
      window.removeEventListener( 'scroll', handleScroll );
    };
  }, [] );

  return (
    <React.Fragment>
      <div className={classes.secondaryNavSection}>
        <div className={classes.secondaryNavigation}>
          <Container maxWidth="lg" className={classes.container}>
            <Button className={classes.mobileToggle} disableFocusRipple disableRipple disableTouchRipple onClick={handleSidebar}>
              <i className="fas fa-bars" />
              <span className={classes.hideContent}>Menu</span>
            </Button>
            <div className={classes.secondaryMenu}>
              <nav role="navigation" className={classes.navBar}>
                <div className={classes.navBarSub}>
                  <div className={classes.socialLinks}>
                    <ul className="social-media-links--platforms platforms inline horizontal">
                      <li>
                        <a href="https://www.facebook.com/3ieimpact" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                          <span className="fab fa-facebook fa-2x" />
                        </a>
                      </li>
                      <li>
                        <a href="https://x.com/3ieNews" target="_blank" rel="noopener noreferrer" aria-label="X">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20" height="20" aria-hidden="true" focusable="false" style={{ display: 'inline-block', verticalAlign: 'middle', color: '#fff' }}>
                            <path fill="currentColor" d="M357.2 48L427.8 48 273.6 224.2 455 464 313 464 201.7 318.6 74.5 464 3.8 464 168.7 275.5-5.2 48 140.4 48 240.9 180.9 357.2 48zM332.4 421.8l39.1 0-252.4-333.8-42 0 255.3 333.8z" />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/company/3ieimpact" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                          <span className="fab fa-linkedin fa-2x" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.youtube.com/3ieimpact" target="_blank" rel="noopener noreferrer" aria-label="Youtube">
                          <span className="fab fa-youtube fa-2x" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/3ieimpact" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                          <span className="fab fa-instagram fa-2x" />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <ul>
                    <li>
                      <a href={`${SITE_LINK}blogs`} title="Blogs" rel="noopener noreferrer">Blogs</a>
                    </li>
                    <li>
                      <a href={`${SITE_LINK}about-us/jobs`} title="Jobs" rel="noopener noreferrer">Careers</a>
                    </li>
                    <li>
                      <a href={`${SITE_LINK}events`} title="Events" rel="noopener noreferrer">Events</a>
                    </li>
                    <li>
                      <a href={`${SITE_LINK}media`} title="Media" rel="noopener noreferrer">Media</a>
                    </li>
                    <li>
                      <a href={`${SITE_LINK}newsletter`} title="Newsletter" rel="noopener noreferrer">Newsletter</a>
                    </li>
                    <li>
                      <a href={`${SITE_LINK}resources`} title="Resources" rel="noopener noreferrer">Resources</a>
                    </li>
                    <li>
                      <a href={`${SITE_LINK}support-us`} title="Donate" rel="noopener noreferrer">Donate</a>
                    </li>
                  </ul>
                </div>
              </nav>
              <div className={classNames( classes.navBarSub, classes.navBarLogin )}>
                <ul>
                  {!data.isLoggedIn && (
                    <React.Fragment>
                      <li>
                        <Button
                          className={classNames( classes.defaultLinkButton, classes.login )}
                          onClick={updateLoginDialog}
                        >
                          Login
                        </Button>
                      </li>
                      <li style={{ paddingLeft: '1.5rem' }}>
                        <Button
                          className={classes.signUp}
                          onClick={updateSignUpDialog}
                        >
                          Sign Up
                        </Button>
                      </li>
                    </React.Fragment>
                  )}
                  {data.isLoggedIn && (
                    <li className={classes.myAccount}>
                      <Button aria-controls="simple-menu1" onClick={handleClick}>My Account</Button>
                      <Menu
                        classes={{ paper: classes.menuPaper, list: classes.menuList }}
                        id="simple-menu1"
                        getContentAnchorEl={null}
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean( anchorEl )}
                        onClose={handleClose}
                        elevation={0}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'center',
                        }}
                      >
                        <MenuItem className={classes.menuItemList}>
                          <Link to="/saved-searches">Saved Searches</Link>
                        </MenuItem>
                        <MenuItem className={classes.menuItemList}>
                          <Link to="/recent-searches">Recent Searches</Link>
                        </MenuItem>
                        <MenuItem className={classes.menuItemList}>
                          <Link to="/bookmarks">Bookmarks</Link>
                        </MenuItem>
                        <MenuItem className={classes.menuItemList}>
                          <Link to="/settings">Settings</Link>
                        </MenuItem>
                        {data.isAdmin && (
                          <MenuItem className={classes.menuItemList}>
                            <a href={adminUrl} target="_blank" rel="noopener noreferrer">Admin</a>
                          </MenuItem>
                        )}
                        <MenuItem className={classes.menuItemList} onClick={handleLogout}>Logout</MenuItem>
                      </Menu>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </Container>
          <Login handleEmail={handleEmail} />
          <SignUpForm />
          <ForgotPassword email={email} />
          <ResetPassword />
        </div>
      </div>
      <div className={classes.headerSection}>
        <nav role="navigation" style={sidebarMenu ? { position: 'fixed' } : { position: 'static' }} className={scrollClass ? classNames( classes.mainNavBar, classes.scrolled ) : classes.mainNavBar}>
          <Container maxWidth="lg" className={classes.container}>
            <div className={classes.navBarLogo}>
              <a href={`${SITE_LINK}`} rel="noopener noreferrer" className={classes.navBarBrand}>
                <img src={Logo} alt="3IE Logo" />
              </a>
            </div>
            <div className={classes.navBarCollapse}>
              <Button className={sidebarMenu ? classNames( classes.mobileToggle, classes.mobNavCloseBtn ) : classes.mobileToggle} disableFocusRipple disableRipple disableTouchRipple onClick={handleSidebar}>
                <i className="fas fa-bars" />
                <span className={classes.hideContent}>Menu</span>
              </Button>
              <ul className={classes.navBarNav}>
                <li className={classNames( classes.navItem, classes.navDropdown, classes.navDropdownShow, classes.megaMenuItem )}>
                  <div>
                    <a href={`${SITE_LINK}about`} rel="noopener noreferrer" className={classes.navILink} title="About">About</a>
                    <i className="caret fas fa-angle-down" />
                  </div>
                  <div className={classNames( classes.dropdownMenu, classes.fullWidthDropdownMenu )}>
                    <AboutUs />
                  </div>
                </li>
                <li className={classNames( classes.navItem, classes.navDropdown, classes.navDropdownShow, classes.megaMenuItem )}>
                  <div>
                    <a href={`${SITE_LINK}what-we-offer`} rel="noopener noreferrer" className={classes.navILink} title="What we offer">What we offer</a>
                    <i className="caret fas fa-angle-down" />
                  </div>
                  <div className={classNames( classes.dropdownMenu, classes.fullWidthDropdownMenu )}>
                    <WhatWeOffer />
                  </div>
                </li>
                <li className={classNames( classes.navItem, classes.navDropdown, classes.navDropdownShow, classes.megaMenuItem )}>
                  <div>
                    <a href={`${SITE_LINK}our-work`} rel="noopener noreferrer" className={classes.navILink} title="Our work">Our work</a>
                    <i className="caret fas fa-angle-down" />
                  </div>
                  <div className={classNames( classes.dropdownMenu, classes.fullWidthDropdownMenu )}>
                    <OurWork />
                  </div>
                </li>
                <li className={classNames( classes.navItem, classes.navDropdown, classes.navDropdownShow, classes.megaMenuItem )}>
                  <div>
                    <a href={`${SITE_LINK}evidence-hub`} rel="noopener noreferrer" className={classes.navILink} title="Evidence Hub">Evidence Hub</a>
                    <i className="caret fas fa-angle-down" />
                  </div>
                  <div className={classNames( classes.dropdownMenu, classes.fullWidthDropdownMenu )}>
                    <EvidenceHub />
                  </div>
                </li>
                <li>
                  <a href={`${SITE_LINK}impact`} rel="noopener noreferrer" className={classNames( classes.navILink, classes.navImpact )} title="Impact">Impact</a>
                </li>
              </ul>
            </div>
          </Container>
        </nav>
      </div>
      {sidebarMenu && (
        <div className={classes.mobileMenuNew}>
          <SideList handleLogout={handleLogout} />
        </div>
      )}
    </React.Fragment>
  );
};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const combinedStyles = combineStyles( globalStyles, styles );

const enhance = compose(
  withStyles( combinedStyles ),
  withRouter,
);

export default enhance( Header );
